import {Tooltip} from '@material-ui/core';
import {Translate} from 'react-redux-i18n';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {getPrivacyPolicyPath} from '../../utils/path';

const PrivacyPolicyLabel = ({isError}) => {
  const currentLocale = useSelector(state => state.i18n.locale);

  return (
    <>
      <span
        className={isError ? 'error' : ''}
        data-id='privacy_policy_text1'
      >
        <Translate value={'textsToValidate.accept.privacyPolicy_1'}/>
      </span>
      <Tooltip title={<Translate value="textsToValidate.tooltip"/>}>
        <a
          href={getPrivacyPolicyPath(currentLocale)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span
            className={isError ? 'error' : ''}
            data-id='privacy_policy_text2'
          >
            <Translate value={'textsToValidate.accept.privacyPolicy_2'}/>
          </span>
        </a>
      </Tooltip>
      <span
        className={isError ? 'error' : ''}
        data-id='privacy_policy_text3'
      >
        <Translate value={'textsToValidate.accept.required'}/>
      </span>
    </>
  );
};

PrivacyPolicyLabel.propTypes = {
  isError: PropTypes.bool.isRequired
};

export default PrivacyPolicyLabel;
